import { createSlice } from '@reduxjs/toolkit';

const navBreadcrumbSlice = createSlice({
  name: 'navBreadcrumb',
  initialState: {
    crumbs: [],
    pendingCrumbClick: null,
  },
  reducers: {
    setCrumbs(state, action) {
      return {
        ...state,
        crumbs: action.payload,
      };
    },
    pushCrumb(state, action) {
      const existingIndex = state.crumbs.findIndex(
        (crumb) => crumb.id === action.payload.id,
      );

      const crumbs = existingIndex !== -1
        ? state.crumbs.slice(0, existingIndex + 1)
        : [...state.crumbs, action.payload];

      return {
        ...state,
        crumbs,
      };
    },
    sliceCrumbs(state, action) {
      return {
        ...state,
        crumbs: state.crumbs.slice(0, action.payload + 1),
      };
    },
    clearCrumbs(state) {
      return {
        ...state,
        crumbs: [],
      };
    },
    triggerCrumbClick(state, action) {
      // action.payload = { crumb, index }
      return {
        ...state,
        pendingCrumbClick: action.payload,
      };
    },
    clearPendingCrumbClick(state) {
      return {
        ...state,
        pendingCrumbClick: null,
      };
    },
  },
});

export const {
  setCrumbs, pushCrumb, sliceCrumbs, clearCrumbs, triggerCrumbClick, clearPendingCrumbClick,
} = navBreadcrumbSlice.actions;

export default navBreadcrumbSlice.reducer;
